// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

import { index } from 'd3-array';
import { audioplayer } from './audioplayer';

document.addEventListener('DOMContentLoaded', function (event) {
  audioplayer(index, true);
});

//// Write your code!

let article = document.querySelector('article');
let charactersToggle = document.getElementsByName('characters-selection');

function showSimplified() {
  article?.classList.remove('tc');
  document.querySelectorAll('span.traditional').forEach((x) => {
    x.setAttribute('aria-hidden', 'true');
  });
  article?.classList.add('sc');
  document.querySelectorAll('span.simplified').forEach((x) => {
    x.setAttribute('aria-hidden', 'false');
  });
  audioplayer(index, false);
}
function showTraditional() {
  article?.classList.remove('sc');
  document.querySelectorAll('span.simplified').forEach((x) => {
    x.setAttribute('aria-hidden', 'true');
  });
  article?.classList.add('tc');
  document.querySelectorAll('span.traditional').forEach((x) => {
    x.setAttribute('aria-hidden', 'false');
  });
  audioplayer(index, false);
}

charactersToggle.forEach((x) => {
  x.addEventListener('change', function () {
    this.value == 'traditional' ? showTraditional() : showSimplified();
  });
});
